{
  "api": {
    "locationValidationTitle": "Kami tidak dapat mengesahkan lokasi anda",
    "thresholdTitle": "Tidak tepat pada masanya untuk daftar masuk",
    "warehouseUnavailableTitle": "Gudang tidak tersedia",
    "warehouseUnavailableMessage": "Sila hubungi kakitangan kemudahan untuk meneruskan dengan daftar masuk secara manual",
    "characterLimitTitle": "Input melebihi had aksara",
    "genericTitle": "Daftar masuk gagal. Sila cuba lagi.",
    "recaptchaTitle": "Pengesahan gagal",
    "recaptchaMessage": "Kami tidak dapat mengesahkan permintaan anda. Sila cuba lagi atau hubungi kakitangan kemudahan."
  }
}
